















import { Component, Vue, Prop } from 'vue-property-decorator';
import _ from 'lodash';
import axios from 'axios';
import PeriodBar from '@/components/PeriodBar.vue'
import CourseDetail from '@/models/CourseDetail';

@Component({
  components: { PeriodBar }
})
export default class CourseView extends Vue {
  @Prop()
  private courseId!: string;

  private course: CourseDetail | null = null;

  private attributes = {
    'ingangseis': 'Ingangseis',
    'inhoud': 'Inhoud',
    'leerdoel': 'Leerdoelen',
    'onderwijsvorm': 'Werkvorm en contacturen',
    'kosten': 'Kosten',
    'aanbevolenVoorkennis': 'Aanbevolen voorkennis',
    'verplichteVoorkennis': 'Verplichte voorkennis',
    'studiemateriaal': 'Studiemateriaal',
    'toetsvorm': 'Toetsing',
    'bijzonderheden': 'Opmerkingen',
    'aanmelden': 'Aanmelden'
  }

  created() {
    axios
      .get(`https://fakecatalog.blob.core.windows.net/$web/${this.courseId}.json`)
      .then((d) => this.course = d.data);
  }
}
